import { useNavigate } from 'react-router-dom';
import Pen from '@/assets/media/SVGComponents/Pen';
import Trash from '@/assets/media/SVGComponents/Trash';

const TableRows = ({ rows, setShowModal, setUserEmail, showAmount = false, showActionButtons = true }) => {
	const navigate = useNavigate();

	const handleOpenModal = (e, emailParam) => {
		setShowModal(true);
		setUserEmail(emailParam);
	};

	return (
		<>
			{rows.map((row) => (
				<tr key={row.id}>
					<td>
						{row.firstname} {row.lastname}
					</td>
					<td>{row.phone_number}</td>
					<td>{row.email}</td>
					{showAmount && <td>{row.total_amount}€</td>}
					{showActionButtons && (
						<td className="flex items-center justify-center gap-2">
							<button type="button" onClick={() => navigate(`/back-office/settings/users/${row.email}/edition`)}>
								<Pen color="#A2924A" width={40} height={40} />
							</button>

							<button type="button" className="m-2" onClick={(e) => handleOpenModal(e, row?.email)}>
								<Trash color="#A2924A" width={40} height={40} />
							</button>
						</td>
					)}
				</tr>
			))}
		</>
	);
};

export default TableRows;
